// external
export const licenseId = '<%= licenseId %>';
export const widgetHost = '<%= widgetHost %>';
export const locationsLimit = '<%= locationsLimit %>';

// internal
export const cssNamespace = '.da0156dfc57b9ef01669068861c5cb38';
export const protocol = '<%= protocol %>';
export const version = '<%= version %>';
